import React, { useEffect, useState } from 'react';

import { useApp } from 'contexts/AppContext';

import { GEOINTERFACE } from 'utils/rest';

import { Select } from 'components/Inputs';
import { Container, Item, Row } from 'components/Layout';
import { Loading } from 'components/Loading';

import { GeoInterfaceCustomization } from './GeoInterfaceCustomization';
import { IsochronyCustomization } from './IsochronyCustomization';
import { RadiusCustomization } from './RadiusCustomization';

const checkGeoAvailability = (type, domain) => {
  return (
    domain.geoInterfaces.includes(type) || domain.geoInterfaces.length === 0
  );
};

export const ZdcInput = ({ value, onChange = () => null }) => {
  const { domainConfig } = useApp();
  const [geoInterfaces, setGeoInterfaces] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState([]);
  const [audienceType, setAudienceType] = useState(value.audienceType);
  const [parameters, setParameters] = useState(value.parameters);

  const defaultValue = {
    isochrony: {
      time: 15,
      unit: 'min',
      transportation: 'pedestrian'
    },
    radius: { unit: 'km', distance: 20 }
  };

  const geoInterface = geoInterfaces.find(el => el.type === audienceType);

  const onChangeParams = newParams => {
    setParameters(newParams);
  };

  const buildOptions = (geoInterfacesList = []) => {
    const newOptions = [
      { label: 'Isochronie', value: 'isochrony' },
      ...(checkGeoAvailability('radius', domainConfig)
        ? [{ label: 'Rayon', value: 'radius' }]
        : [])
    ];
    geoInterfacesList.forEach(element => {
      newOptions.push({
        label: element.name.fr,
        value: element.type
      });
    });

    return newOptions;
  };

  const getGeoInterfaces = async () => {
    const res = await GEOINTERFACE.getGeoInterfaces();
    setGeoInterfaces(res);
    setOptions(buildOptions(res));
  };

  const initialize = async () => {
    await getGeoInterfaces();

    setIsLoading(false);
  };

  const onChangeOption = option => {
    if (option === value?.audienceType) {
      setParameters(value.parameters);
    } else {
      setParameters(defaultValue[option] || []);
    }
    setAudienceType(option);
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!isLoading) {
      onChange({ parameters, audienceType });
    }

    // eslint-disable-next-line
  }, [parameters]);

  return (
    <Container>
      <Loading color="activation" loading={isLoading}>
        <Row spacing={0} justify="flex-start">
          <Item xs={6}>
            <Select
              title="Zone de chalandise"
              options={options}
              value={audienceType}
              onChange={onChangeOption}
              small
            />
          </Item>
        </Row>
        <Row spacing={0}>
          <Item justify="flex-start">
            {audienceType === 'radius' && (
              <RadiusCustomization
                params={parameters}
                setParams={onChangeParams}
              />
            )}
            {audienceType === 'isochrony' && (
              <IsochronyCustomization
                params={{ ...parameters, unit: parameters?.unit || 'min' }}
                setParams={onChangeParams}
              />
            )}
            {!!geoInterface && (
              <GeoInterfaceCustomization
                params={parameters}
                setParams={onChangeParams}
                geoInterface={geoInterface}
                audienceType={audienceType}
              />
            )}
          </Item>
        </Row>
      </Loading>
    </Container>
  );
};

export default ZdcInput;
